var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.805 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12ZM.472 8a7.333 7.333 0 1 1 14.666 0A7.333 7.333 0 0 1 .472 8Zm7.333-4.667c.368 0 .667.299.667.667v3.588l2.298 1.149a.667.667 0 0 1-.596 1.193L7.507 8.596A.667.667 0 0 1 7.138 8V4c0-.368.299-.667.667-.667Z",
  clipRule: "evenodd"
})));
export default SvgClock;